module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summer_courses_en-b3a71b06338bd48db13cc764cebce1fa.png";